import { XUser } from '@core/utils';
import { getNavItems } from './getNavItems';

const traverseNavTree = (navTree, userRoles) => {
  let copy = [...navTree];

  copy.forEach((e) => {
    if (e.roles.length === 0 || XUser.isUserAllowed(e.roles, userRoles)) {
      if (e.items) {
        e.items = traverseNavTree(e.items, userRoles);
      }
    } else {
      copy = copy.filter((y) => {
        if (y.text === e.text && y.path === e.path) {
          return false;
        }

        return true;
      });
    }
  });

  return copy;
};

export const selectAllowedNavItems = (userRole, rawNavItems, i18nT) => {
  // const userRoles = XUser.getUserRoles(role);

  const navItems = getNavItems(rawNavItems, null, i18nT);

  // const navItems = prepareNavItems(rawNavItems);

  // console.log(navItems);
  // const nav = traverseNavTree(navItems, userRoles);

  console.log((userRole & 2) > 0);
  if ((userRole & 2) > 0) {
    return navItems;
  }
  return navItems.filter((navItem:any) => {
    return navItem.roles?.some((role: any) => (role & userRole) > 0);
  });
};

const getRoutes = (nav, routes) => {
  nav.forEach(({ items, path, component }) => {
    if (path && component) {
      routes.push({
        path,
        component
      });
    }

    if (items) {
      getRoutes(items, routes);
    }
  });
};

export const selectAllowedRoutes = (role, rawNavItems, i18nT) => {
  const nav = selectAllowedNavItems(role, rawNavItems, i18nT);

  const routes = [];

  getRoutes(nav, routes);

  return routes;
};
